import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { applyInitialColorScheme } from '@seahorse/theme';
import { SuperUserAppModule } from './app/super-user-app.module';

// Before bootstrap, so the page doesn't flash white first in dark mode.
applyInitialColorScheme();

platformBrowserDynamic()
  .bootstrapModule(SuperUserAppModule)
  .catch((err) => console.error(err));
